import React from 'react';
import { Grid, CircularProgress } from '@mui/material';
import CategoryCard from './CategoryCard';
import { useEffect, useState } from 'react';
import { fetchCategories } from '../../common/api/linktivities';

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchCategories()
      .then((res) => {
        let tempCategories = res.data;
        try {
          tempCategories.sort(function (a, b) {
            return a.category_id - b.category_id;
          });
        } catch (err) {
          console.log(err.message);
        }
        setCategories(tempCategories);
      })
      .catch((err) => {
        console.log(err.message);
        setCategories([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      {loading ? (
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <CircularProgress color='secondary' />
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          spacing={1}
          direction='row'
          alignItems='center'
          justifyContent='center'
        >
          {categories.map((category) => (
            <Grid item key={category.category_id}>
              <Grid
                container
                spacing={0}
                direction='row'
                alignItems='center'
                justifyContent='center'
              >
                <Grid item sx={{ margin: '5px' }}>
                  <CategoryCard
                    categoryId={category.category_id}
                    categoryName={category.category_name}
                    thumbnail={category.thumb}
                    thumbnailMotion={category.thumb_motion}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
}
